import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { vsprintf } from 'sprintf-js';
import { AppHelper } from '../../helpers/AppHelper';
import { SearchBar } from '../../common/components/SearchBar';
import { MultiselectFilterBar } from '../../common/components/MultiselectFilterBar';
import { VenueDetails } from '../../components/VenueDetails';
import { AppConfig } from '../../AppConfig';
import { Chip, Grid } from '@material-ui/core';
import { Doughnut, Pie } from 'react-chartjs-2';
import { venueCommandsFieldDef, venueStateOptions } from '../../data/data';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { helpers } from 'handlebars';
import AppWebSocketHelper from '../../helpers/AppWebSocketHelper';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { VenueAdsPlayer } from '../../components/VenueAdsPlayer';
import { SingleSelectDropDown } from '../../common/components/SingleSelectDropDown';
import { Controller } from '../../common/Controller';
import { VenueEsperInfo } from '../../components/VenueEsperInfo';
import { VenueSummary } from '../../components/VenueSummary';

export class VenuesOrg extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.customFieldResults = []
    this.pageKey = 'Venues'
    this.pageTitle = Helper.getString('venues')
    this.orgId = this.props.match.params.orgId
    this.uploadLocation = this.orgId
    this.defaultState = 'LIVE'
    this.defaultOnlineStatus = '_ALL'
    this.sitesById =  {}
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'venues-of-org'], queryParams: { orgId: this.orgId, pb: 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefDeviceActions', state: this.defaultState, onlinestatus: this.defaultOnlineStatus } },
      { method: 'GET', paths: ['items'], queryParams: { groupId: 'displayads' + this.orgId } },
      { method: 'GET', paths: ['items'], queryParams: { groupId: 'audioads' + this.orgId } },
      //{ method: 'GET', paths: ['campaigns'], queryParams: { groupId: this.orgId } },
      { method: 'GET', paths: ['miscs', 'campaigns'], queryParams: { groupId: this.orgId, pb: 'fieldDef', state: 'LIVE', shallow: true, limit: 10000} },
      { method: 'GET', paths: ['devicetags'], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
      { method: 'GET', paths: ['orgs', this.orgId] },
      { method: 'GET', paths: ['devicecfs'], queryParams: { groupId: this.orgId, pb: 'fieldDefCfSuggestions' } }
    ]
    this.defaultVenueParam = {...this.toFetch[0]}
    this.tableHeadersMap = {
      Index: (current) => {
        return (
          <span className={css(Styles.indexStyle)}>{current.__index + 1}</span>
        )
      },
      Venue: (current) => {
        const site = this.sitesById[current.orgId]
        return (
          <div className={css(Styles.venueColumn)}>
            <VenueSummary item={current} site={site} />
          </div>
        )
      },
      Info: (current) => {
        return (
          <div>
            <div className={css(Styles.sideBySideInfo)}>
              {/* column 1 */}
              <div>
                {/* Active */}
                <div className={css(Styles.infoTextHolder)}>
                  {current.latestDeviceFeed && current.latestDeviceFeed.currentTs &&
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs)}
                    </span>
                  }
                  {!current.latestDeviceFeed &&
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {`Active : ${Helper.getString('unknown')}`}
                    </span>
                  }
                </div>
                {/* APP */}
                {!AppHelper.isNonApkDevice(current) &&
                  <div className={css(Styles.infoTextHolder)}>
                    {current.latestDeviceFeed && current.latestDeviceFeed.versionCode &&
                      <span className={css(Styles.spanValue, Styles.line2)}>
                        {`App : #${current.latestDeviceFeed.versionCode}`}
                      </span>
                    }
                    {!current.latestDeviceFeed &&
                      <span className={css(Styles.spanValue, Styles.line2)}>
                        {`App : ${Helper.getString('unknown')}`}
                      </span>
                    }
                  </div>
                }

                { this.orgType === 'PARTNER' &&
                <Fragment>
                  {/* Audio Ads */}
                  <div className={css(Styles.infoTextHolder)}>
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {`Audio Ads: ${current.audioAdPartnerIds && current.audioAdPartnerIds.length || 0}`}
                    </span>
                  </div>
                  {/* Tags */}
                  <div className={css(Styles.infoTextHolder)}>
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {`Tags : ${current.tagsPartner && current.tagsPartner.length || 0}`}
                    </span>
                  </div>
                </Fragment>
                }
              </div>
              {/* column 2 */}
              <div>
                {/* Orientation */}
                <div className={css(Styles.infoTextHolder)}>
                  <span className={css(Styles.spanValue, Styles.line2)}>
                    {`Orientation : ${current._ORIENTATION || 'UNKNOWN'}`}
                  </span>
                </div>
                { this.orgType === 'PARTNER' &&
                <Fragment>
                  {/* Campaign */}
                  <div className={css(Styles.infoTextHolder)}>
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {`Disp Campaigns : ${current.campaignsPartner && current.campaignsPartner.length || 0}`}
                    </span>
                  </div>
                  {/* Ads */}
                  {/* <div className={css(Styles.infoTextHolder)}>
                    <span className={css(Styles.spanValue, Styles.line2)}>
                      {`Disp Ads : ${current.imageAdPartnerIds && current.imageAdPartnerIds.length || 0}`}
                    </span>
                  </div> */}
                </Fragment>
                }
              </div>
            </div>
            <div>
              {current.tagsPartner &&
                <div className={css(Styles.tagHolder)}>
                  {AppHelper.getTagChips(current.tagsPartner, this.state.tags).map((x, i) =>
                    <Chip key={'chip_' + i} label={x} size='small' className={css(Styles.tagChip)} />
                  )}
                </div>
              }
            </div>
          </div>
        )
      },
      Status: (current) => {
        return (
          <Fragment>
            <div className={css(Styles.statusHolder)}>
              <div className={css(Styles.displayInRow)}>
                {
                  (current.latestDeviceFeed && current.latestDeviceFeed.currentTs) ?
                    AppHelper.getVenueStatus(Helper.currentTs() - current.latestDeviceFeed.currentTs)
                    : AppHelper.offlineStatus()
                }
                <span>{AppUiHelper.getVenueSignalStatus(current)}</span>
              </div>
              {(this.orgType !== 'FA' && this.orgType !== 'PA') && AppHelper.getSyncInfo(current)}
              {/* {AppHelper.getSyncInfo(current)} */}
              {AppHelper.getHdmiInfo(current)}
            </div>
          </Fragment>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.noAdd = true
    this.noTableHead = true
    this.emptyText = (
      <span className={css(Styles.emptyTextHolder)}>
        <span>{Helper.getString('noVenue')}</span>
      </span>
    )
    // ChartsOptions
    this.chartOptions = {
      responsive: true,
      legend: {
        display: true,
        position: 'right',
        margin: {
          top: 20
        },
        labels: {
          boxWidth: 8,
          fontSize: 10,
        },
        onClick: function(e, legendItem) {
          e.preventDefault();
        }
      },
      layout: {
        autoPadding:false,
        padding: {
          top: -10
        }
      },
      maintainAspectRatio: false
    };
    this.allowAccessToRoles = ['VENUES']
    const endPoint = AppConfig.WS.ENDPOINT
    const queryParam = {apiKey:AppConfig.WS.API_KEY, orgId: this.orgId }
    const hearBeatMessage = { iType: 'HEARTBEAT', payload: { orgId: this.orgId } }
    this.socketHelper = new AppWebSocketHelper(endPoint, queryParam, this.onReceiveMessage, hearBeatMessage);
  }

  formatBytesToMbpsOrKbps = (bytes, decimalPlaces = 2) => {
    // Convert bytes to bits
    const bits = bytes * 8;
    // Check if the size is less than 1 Megabit
    if (bits < 1000 * 1000) {
      const kilobits = bits / 1000; // 1 Kb = 1000 bits
      return `${kilobits.toFixed(decimalPlaces)} Kbps`; // Kilobits per second
    } else {
      // Convert bits to Megabits
      const megabits = bits / (1000 * 1000); // 1 Mb = 1,000,000 bits
      return `${megabits.toFixed(decimalPlaces)} Mbps`; // Megabits per second
    }
  }


  _init() {
    this.fetchItems()
    this.socketHelper.connect()
  }

  refreshAll() {
    if (this.socketHelper) {
      this.socketHelper.close()
    }
    this._init()
  }

  componentDidMount() {
    this._init()
  }

  componentWillUnmount() {
    if (this.socketHelper) {
      this.socketHelper.close()
    }
  }

  onReceiveMessage = (message) => {
    try {
      const parsedJsonMessage = JSON.parse(message)
      if (parsedJsonMessage && parsedJsonMessage.iType && parsedJsonMessage.iType === 'CONSOLE_SYNC_STATUS' && parsedJsonMessage.payload) {
        this.updateDeviceInfo(parsedJsonMessage.payload)
      }
    } catch (e) {
      console.error(e, message)
    }
  }

  updateDeviceInfo = (parsedJsonMessage) => {
    const { deviceId, orgId } = parsedJsonMessage;
    const newInfo = {
      deviceOutOfSync: parsedJsonMessage.deviceOutOfSync,
      syncPercent: parsedJsonMessage.syncPercent,
      syncBandwidth: parsedJsonMessage.syncBandwidth,
    };
    const allItems = this.state.items.map((item) => {
      if (item.deviceId === deviceId && this.orgId === orgId) {
        return {
          ...item,
          ...newInfo,
        }
      }
      return item
    })
    this.setState({ items: allItems })
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 200
  }

  onFetchSuccess(results, options) {
    console.log('onFetchSuccess',results, options)

    // Pagination -- Start
    const { fetchNext } = options || {}
    if(results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const updatedItems = this.state.items.concat(results[0].items)
      this.sitesById = {
        ...this.sitesById,
        ...(results[0].sitesById || {})
      }
      for(const item of updatedItems) {
        if(item.orgId && this.sitesById[item.orgId]) {
          item.siteInfo = { ...this.sitesById[item.orgId] }
        }
      }
      this.setState({
        items: AppHelper.processVenueItems(updatedItems),
        nextPageState: ApiHelper.State.READY,
      })
      return
    }
    // Pagination -- ENDS

    this.org = results[5]
    const venuesResult = results[0]
    if(venuesResult.dashboard || venuesResult.stats) this._generateChartsFromStats(venuesResult.dashboard || venuesResult.stats)
    this.formDefinition = this.fieldDef = {...venuesResult.fieldDef, formId: 'venueEditForm'}
    if(this.options && this.options.pageForOrgType && this.options.pageForOrgType === 'PARTNER') {
      this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(x => x.key && x.key !== 'imageAdPartnerIds' ) // Display ads commented.
    }
    this.fieldDefInstallation = venuesResult.fieldDefInstallation
    this.fieldDefInstallation.dialogHeading = 'Registration'
    this.fieldDefDeviceActions = venuesResult.fieldDefDeviceActions
    // Added SL_NEXT on has feature
    if (AppHelper.hasFeature(this.org, 'SL_NEXT')) {
      const field = this.fieldDefDeviceActions.steps[0].fields.find(i => i.key === 'action') // finds the action field if exist
      if (field) field.options.push({ key: 'SL_NEXT', label: 'Switch Input' }) // If action fields present then only push new item into its options
    }
    this.fieldDefVenueGen = venuesResult.fieldDefVenueGen
    const fields = []
    this.orgType = venuesResult.groupId

    if (this.orgType === 'FA' || this.orgType === 'PA' || this.orgType === 'SITE') {
      this.export = {
        buttonTitle: 'Download',
        headers: {
          deviceCode: 'venueCode',
          title: 'title',
          'site.title': 'siteTitle',
          'site.address': 'siteAddress',
          extId: 'extId',
          _VENUETYPE: '_VENUETYPE',
          // screenType: 'screenType',
          serialNumber: 'serialNumber',
          screenPlacement: 'screenPlacement',
          screenDimension: 'screenDimension',
          _ORIENTATION: 'orientation',
          _ADDRESS: 'address',
          _ONLINE_STATUS: 'onlineStatus',
          state: 'state'
        },
        format: 'xlsx'
      }
    } else if (this.orgType === 'PARTNER') {

      const headers = {
        deviceCode: 'venueCode',
        title: 'title',
        'site.title': 'siteTitle',
        'site.address': 'siteAddress',
        extId: 'extId',
        _VENUETYPE: '_VENUETYPE',
        category: 'category',
        // screenType: 'screenType',
        serialNumber: 'serialNumber',
        screenPlacement: 'screenPlacement',
        screenDimension: 'screenDimension',
        screenModel: 'screenModel',
        screenBrand: 'screenBrand',
        _ORIENTATION: 'orientation',
        _ADDRESS: 'address',
        state: 'state',
        _REGISTRATION_STATUS: 'registrationStatus',
        _ONLINE_STATUS: 'onlineStatus'
      }
      if (AppHelper.hasFeature(this.org, 'DEVICE_LIVE_LOC')) {
        headers._LAT = 'screenLat';
        headers._LON = 'screenLon';
      }
      this.export = {
        buttonTitle: 'Download',
        headers: headers,
        format: 'xlsx'
      }
    }

    if(this.orgType === 'PARTNER') {
      this._setupPartner(results)
    }
    this.formDefinition.steps[0].fields.forEach(i => {
      if(Helper.inArray(['title', 'deviceCode'], i.key)) { // will be disabled
        fields.push(i)
      }
      if(this.orgType === 'PARTNER'
        && Helper.inArray(['imageAdPartnerIds', // TODO: deprecate
          'audioAdPartnerIds', 'campaignsPartner', 'tagsPartner', 'extId'], i.key)) {
        if(i.key === 'extId') i.placement = 'left'
        fields.push(i)
      }
      if(this.orgType === 'SITE'
        && Helper.inArray(['imageAdIds', 'audioAdIds'], i.key)) {
        fields.push(i)
      }
    })
    this.formDefinition.steps[0].fields.find(i => i.key === 'title').disabled = true
    this.formDefinition.steps[0].fields.find(i => i.key === 'deviceCode').disabled = true
    this.formDefinition.steps[0].fields = fields
    // Adding Custom Tag
    this.formDefinition.steps[0].fields.map((x) => {
      if (x.type === 'check_box' && x.key === 'tagsPartner') {
        x.addOptions = true
      }
    })

    UiHelper.populateOptions(this.formDefinition, results[1], 'imageAdIds')
    UiHelper.populateOptions(this.formDefinition, results[1], 'imageAdPartnerIds') // TODO: deprecate
    UiHelper.populateOptions(this.formDefinition, results[2], 'audioAdIds')
    UiHelper.populateOptions(this.formDefinition, results[2], 'audioAdPartnerIds')
    UiHelper.populateOptions(this.formDefinition, results[3], 'campaignsPartner') // TODO: enable campaignsPartner
    UiHelper.populateOptions(this.formDefinition, results[4], 'tagsPartner')
    // TODO: for console error we are adding this field
    if (this.orgType === 'PARTNER' && UiHelper.isUserHasRoles(this.allowAccessToRoles)) {
      this.displayCheckBoxTable = true
    }
    if(this.displayCheckBoxTable) venuesResult.items.map(x => x._selected = false)
    this.customFieldResults = results[6]
    this.customFieldDef = this._generateCustomFieldsFormDef()
    this.sitesById = {
      ...this.sitesById,
      ...(results[0].sitesById || {})
    }
    for(const item of venuesResult.items) {
      if(item.orgId && this.sitesById[item.orgId]) {
        item.siteInfo = { ...this.sitesById[item.orgId] }
      }
    }
    this.setState({
      items: AppHelper.processVenueItems(venuesResult.items),
      tags: results[4],
      showCustomField: false,
      stateFilterValue: this.defaultState,
      onlineStatus: this.defaultOnlineStatus
    })
  }

  makeFileName = () => {
    return this.orgId + '-screens-' +  Helper.currentTs()
  }

  _generateChartsFromStats(stats) {
    const allCharts = []
    const backgroundColors = [
      '#645CAA',
      '#A084CA',
      '#BFACE0',
      '#BFACE0',
      '#800080',
      '#EBC7E8',
    ]
    const renameValues = {
      red: 'Offline',
      orange: 'Standby',
      green: 'Online'
    }
    const onlineStatusColors = {
      red: '#FF1512',
      orange: '#e1ad01',
      green: '#238822'
    }
    Object.keys(stats).map(x => {
      const tempData = {
        labels: (x === 'onlineStatus') ? Object.keys(stats[x]).map(x => renameValues[x].toUpperCase() || x) : Object.keys(stats[x]),
        datasets: [
          {
            data: Object.values(stats[x]),
            backgroundColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x,index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            borderColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x,index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            hoverBackgroundColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x,index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            borderWidth: 0,
          },
        ],
      }
      allCharts.push({
        chartTitle: x === 'osVersion' ? Helper.getString('osVersion') : this.camelCaseToCapitalizedWords(x),
        data: tempData
      })
    })
    this.setState({
      chartsData: allCharts
    })
  }

  camelCaseToCapitalizedWords(camelCaseString) {
    try {
      return camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^./, function (str) {
          return str.toUpperCase();
        });
    } catch(e) {
      return camelCaseString
    }
  }

  exportRowItemValue(key, current) {
    const site = this.sitesById[current.orgId] || current.site || current.siteInfo || {}
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber

    switch (key) {
    case 'site.title':
      return site.title || ''
    case 'site.address':
      return site.address || ''
    case 'screenType':
      return current.info && current.info.openoohcategory ? current.info.openoohcategory : ''
    case 'serialNumber':
      return serialNumber || ''
    case 'screenPlacement':
      return current.info && current.info.screenPlacement ? current.info.screenPlacement : ''
    case 'screenDimension':
      return current.info && current.info.screenDimension ? current.info.screenDimension : ''
    case 'category':
      return current.info && current.info.category ? current.info.category : ''
    case 'screenModel':
      return current.info && current.info.screenModel ? current.info.screenModel : ''
    case 'screenBrand':
      return current.info && current.info.screenBrand ? current.info.screenBrand : ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }

  async onFormFieldOptionAdd(options) {
    const { formField, value, formId } = options
    if (this.formDefinition.formId === formId) {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['devicetags']),
        jsonBody: { groupId: this.orgId, title: value }
      })
      const updatedResult = await ApiHelper.callAwait({
        method: 'get',
        paths: ['devicetags'],
        queryParams: { groupId: this.orgId, pb: 'fieldDef' }
      })
      this.formDefinition.steps[0].fields.map(x => {
        if (x.key === formField.key) {
          UiHelper.populateOptions(this.formDefinition, updatedResult, formField.key)
        }
      })
      return updatedResult || {}
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {},
      apiEndPoint: ApiHelper.makeUrlPath(['devices', current.id]),
    });
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiData: { partnerOrgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['devices']),
    });
  }

  onBulkAdd() {
    this.setState({
      apiMethod: 'POST',
      apiData: { orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['miscs', 'venues-bulk-updation']),
    });
  }

  openModalForBulkUpdate() {
    this.formDefinition = this.fieldDefBulkUpdate
    this.formDefinition.formType = 'add'
    this.onBulkAdd()
    this.setState({
      modalOpen: true
    })
  }

  openModalForInstallationEdit(current) {
    console.log('openModalForInstallationEdit:', current);
    this.formDefinition = this.fieldDefInstallation
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current);
    this.setState({
      modalOpen: true
    });
  }

  openModalForDeviceActions(current) {
    console.log('openModalForDeviceActionsEdit:', current);
    this.fieldDefDeviceActions.formType = 'edit'
    this.fieldDefDeviceActions.dialogHeading = current.title
    this.setState({
      modalOpenDeviceActions: true,
      currentSelectedForAction: current,
    });
  }

  checkBoxActions = (checkedItems) => {
    const headerActions = []
    headerActions.push(
      <Tooltip title={Helper.getString('bulkUpdate')} placement='top-start' key={'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => {
            Helper.populateFormDefinitionValues(this.fieldDefBulkUpdate, {venues:checkedItems.map(x => x.id)})
            this.openModalForBulkUpdate()
          }}>fact_check</i>
        </span>
      </Tooltip>
    )
    return headerActions
  }

  customFieldButton(current) {
    return (
      <Tooltip title={Helper.getString('customField')} placement='top-start' key={Helper.getString('customField')}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this._openCustomFieldDialog(current)}>tune</i>
        </span>
      </Tooltip>
    )
  }

  onActions(current) {
    const actions = []
    if(this.orgType === 'PARTNER' || this.orgType === 'SITE') {
      UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
      if(current.installationId) {
        UiHelper.addActionButtonByRole(actions, this.infoButton(current), this.allowAccessToRoles)
      }
    }
    if(this.orgType === 'PARTNER' && AppHelper.hasFeature(this.org, 'DEVICE_LIVE_LOC')) {
      UiHelper.addActionButtonByRole(actions, this.esperInfoButton(current), this.allowAccessToRoles)
    }
    if(this.orgType === 'PARTNER' && AppHelper.hasFeature(this.org, 'REGVENUE')) {
      UiHelper.addActionButtonByRole(actions, this.registrationButton(current), this.allowAccessToRoles)
    }
    // if (this.orgType === 'PARTNER' && !AppConfig.FEATURES_OFF.includes('SEND_COMMAND_TO_SCREEN') && current.installationId) {
    //   actions.push(this.sendCommandButton(current))
    // }
    const customFieldsCount = this.customFieldDef.steps[0].fields.length || 0
    if (this.orgType === 'PARTNER' && customFieldsCount > 0) {
      // actions.push(this.customFieldButton(current))
      UiHelper.addActionButtonByRole(actions, this.customFieldButton(current), this.allowAccessToRoles)
    }
    if(this.orgType === 'PARTNER') {
      UiHelper.addActionButtonByRole(actions, this.deviceActionsButton(current), this.allowAccessToRoles)
      if (current.installationId && !AppConfig.FEATURES_OFF.includes('DISPLAY_ADS_PLAYER')) {
        UiHelper.addActionButtonByRole(actions, this.adPlayerButton(current), this.allowAccessToRoles)
      }
    }
    if(this.orgType === 'PARTNER') {
      UiHelper.addActionButtonByRole(actions, this.deviceTasksButton(current), this.allowAccessToRoles)
    }
    return actions
  }

  onMenuItems = (current) => {
    if (this.orgType !== 'PARTNER') return []

    return [
      UiHelper.actionLinkButton({
        key: `${current.id}-screen-playback-history`,
        title: 'Screen Playback History',
        link: `${this.baseRoute()}/screen-playback-history?screen=${current.deviceCode}`,
        icon: 'video_library'
      })
    ]
  }

  esperInfoButton(current) {
    return (
      <Tooltip title={Helper.getString('liveLocation')} placement='top-start' key={'esperInfoBtn'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.setState({ esperShowInfo: true, device: current })}>fmd_good</i>
          {/* <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => this.setState({ showInfo: true, device: current }) }/> */}

        </span>
      </Tooltip>
    )
  }

  adPlayerButton(current) {
    return (
      <Tooltip title={Helper.getString('adsPlayButtonTitle')} placement='top-start' key={'adsPlayButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.getAdsOfVenue(current)}>play_circle</i>
        </span>
      </Tooltip>
    )
  }

  getAdsOfVenue(current) {
    if (current.installationId) {
      this.setState({
        showAdsPlayer: true,
        showAdsPlayerLoading: true,
        venueAdsPlayerTitle: current.title,
        adsPlayerError: null
      })
      // Job API Call
      ApiHelper.call({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['ivenues'], { installationId: current.installationId, hb: 'NO' })
      }, (err, result) => {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err)
          console.log(errorMessage)
          this.setState({
            adsPlayerError: errorMessage,
            showAdsPlayerLoading: false,
            playableAdsList: [],
            playerOrientation: ''
          })
          return
        }
        const processAds = AppHelper.processAdsForVenuePlayer(result, this.orgType)
        this.setState({ showAdsPlayerLoading: false, playableAdsList: processAds, playerOrientation: result.orientation })
      })
    }
  }

  onCloseAdsPlayer() {
    this.setState({
      showAdsPlayer: false,
      showAdsPlayerLoading: null,
      venueAdsPlayerTitle: '',
      adsPlayerError: null,
      playableAdsList: []
    })
  }

  sendCommandButton(current) {
    return (
      <Tooltip title={Helper.getString('sendCommandTitle')} placement='top-start' key={'commandButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.setState({ showCommandDialog: true, device: current }) }>developer_mode</i>
        </span>
      </Tooltip>
    )
  }

  registrationButton(current) {
    return (
      <Tooltip title='Registration' placement='top-start' key={current.id + 'Reg'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() =>
            this.openModalForInstallationEdit.bind(this)(current)
          }>personal_video</i>
        </span>
      </Tooltip>
    )
  }

  deviceActionsButton(current) {
    return (
      <Tooltip title='Device Actions' placement='top-start' key={current.id + 'Actions'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() =>
            this.openModalForDeviceActions.bind(this)(current)
          }>layers</i>
        </span>
      </Tooltip>
    )
  }

  deviceTasksButton(current) {
    return (
      <Link to={`/admin/${Controller.get().roleHelper().getPathByOrgType('PARTNER')}/` + current.partnerOrgId + '/screens/' + current.deviceCode + '/tasks'}
        key={current.id + '-org'}>
        <Tooltip title='Device Tasks' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>directions_run</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  sendCommandCustomDialogHandle = async (data) =>{
    const {formData, caller} = data
    const payload = {
      venueCodes:this.state.device.deviceCode,
      partnerOrgId: this.orgId,
      command:formData.command
    }
    // Job API Call
    ApiHelper.call({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'bg-push']),
      jsonBody: payload,
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
      this.setState({showCommandDialog: false})
    })
  }

  infoButton(current) {
    return (
      <Tooltip title='Info' placement='top-start' key={'infoBtn'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          {/* <i className='material-icons-outlined' onClick={() => this.setState({ showInfo: true, device: current }) }>info</i> */}
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => this.setState({ showInfo: true, device: current }) }/>
        </span>
      </Tooltip>
    )
  }

  _setupPartner(results) {
    this.headerActions = []
    // this.headerActions = [
    //   {
    //     icon: 'add',
    //     label: 'Bulk Update',
    //     onClick: () => {
    //       Helper.populateFormDefinitionValues(this.fieldDefBulkUpdate, {venues:[]})
    //       this.openModalForBulkUpdate()
    //     }
    //   }
    // ]
    if(AppHelper.hasFeature(this.org, 'ADDVENUE')) {
      this.headerActions.push(
        {
          icon: 'add',
          label: 'New Screen',
          onClick: () => this.openModalForNewVenue()
        }
      )
    }
    this.headerActions.push(
      {
        icon: 'autorenew',
        label: 'Refresh', //Rfsh
        type: 'icon-mobile',
        onClick: () => this.refreshAll()
      }
    )
    this.fieldDefBulkUpdate = {
      dialogHeading: 'Bulk Screen Update',
      steps: [
        {
          fields: [
            {
              key: 'venues',
              type: 'check_box',
              label: 'Screens',
              hint: 'Select Screens',
              options: [],
              v_required: { // eslint-disable-line camelcase
                value: true,
                err: 'Select Screens'
              },
              placement: 'left',
            },
            {
              key: 'campaignsPartner',
              type: 'check_box',
              label: 'Display Campaigns (Site partner)',
              hint: 'Select Display Campaigns',
              options: [],
              v_required: { // eslint-disable-line camelcase
                value: false,
                err: 'Select Display Campaigns'
              },
              placement: 'left'
            },
            {
              key: 'audioAdPartnerIds',
              type: 'check_box',
              label: 'Audio Ads (Partner)',
              hint: 'Select Audio Ads',
              options: [],
              v_required: { // eslint-disable-line camelcase
                value: false,
                err: 'Select Audio Campaigns'
              },
              placement: 'left'
            },
            {
              key: 'imageAdPartnerIds',
              type: 'check_box',
              label: 'Display Ads (Partner) (legacy)',
              hint: 'Select Display Ads',
              options: [],
              v_required: { // eslint-disable-line camelcase
                value: false,
                err: 'Select Display Ads'
              },
              placement: 'left'
            }
          ]
        }
      ]
    }
    this.addNewLabel = 'Bulk Update'
    const venues = {
      items: [ { id: '_ALL', title: 'All' } ]
    }
    results[4].items.map((x)=>{
      venues.items.push({...x, id: `tag:${x.id}`,title:`(Tag: ${x.title})`})
    })
    venues.items = venues.items.concat(results[0].items)
    UiHelper.populateOptions(this.fieldDefBulkUpdate, venues, 'venues')
    UiHelper.populateOptions(this.fieldDefBulkUpdate, results[1], 'imageAdPartnerIds')
    UiHelper.populateOptions(this.fieldDefBulkUpdate, results[2], 'audioAdPartnerIds')
    UiHelper.populateOptions(this.fieldDefBulkUpdate, results[3], 'campaignsPartner')
  }

  openModalForNewVenue() {
    this.formDefinition = this.fieldDefVenueGen
    this.formDefinition.formType = 'add'
    this.onAdd();
    this.setState({
      modalOpen: true
    })
  }

  _openCustomFieldDialog = (current) => {
    this.customFieldDef = this._generateCustomFieldsFormDef(current)
    this.setState({
      showCustomField: true,
      currentEditItem:current
    })
  }
  _getCustomEntries = (existingSuggestions, currentVenueSuggestions) => {
    if (Object.keys(currentVenueSuggestions).length > 0) {
      currentVenueSuggestions.forEach(option => {
        // Check if the option is already in existingSuggestions
        const isPresent = existingSuggestions.some(suggestion => suggestion.key === option);
        // If the option is not present, add it to existingSuggestions
        if (!isPresent) {
          existingSuggestions.push({ key: option, text: option });
        }
      });
      return existingSuggestions;
    }
    return existingSuggestions || []
  }
  _generateCustomFieldsFormDef = (current = {}) => {
    let currentVenueCfs = {}
    if (current && current.cfs) {
      currentVenueCfs = current.cfs
    }
    const customFieldsResp = this.customFieldResults
    // console.log('customFieldsResp', customFieldsResp)
    const fields = [];
    if (customFieldsResp && customFieldsResp.items && customFieldsResp.items.length > 0) {
      let leftPlacement = true
      customFieldsResp.items.forEach((item) => {
        // Suggestions
        let customOptions = Object.values(item.suggestions).map(suggestion => {
          return { key:suggestion.title, text:suggestion.title };
        });
        // Custom Entires pre fill
        if (currentVenueCfs && currentVenueCfs[item.id]) {
          customOptions = this._getCustomEntries(customOptions, currentVenueCfs[item.id])
        }
        // Field Def
        const customInputField = {
          key: item.id,
          type: 'check_box',
          label: item.title,
          hint: 'Select Suggestions',
          options: customOptions,
          // eslint-disable-next-line camelcase
          v_required: {
            value: false,
            err: 'Select Suggestions ' + item.title
          },
          value: currentVenueCfs[item.id] || [],
          placement: leftPlacement ? 'left' : 'right',
          addOptions: true
        };
        leftPlacement = !leftPlacement
        fields.push(customInputField);
      });
    }
    const completeFormDef = {
      formType:'edit',
      title: Helper.getString('customField'),
      loadingText: 'No options found',
      addPrefix: 'Add',
      steps:[{fields}]
    }
    return completeFormDef
  }

  _handelCustomFieldSubmit = (data) => {
    const {formData, caller} = data
    const payload = {
      cfs:formData
    }
    // Job API Call
    ApiHelper.call({
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['devices', this.state.currentEditItem.id]),
      jsonBody: payload,
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
      this.setState({showCustomField: false})
      this.fetchItems()
    })
  }
  _handelCustomFieldAddNewOption = async (options) => {
    const { formField, value, formId } = options

    const existingList = []
    if (formField.options && formField.options.length > 0) {
      formField.options.forEach(x => existingList.push({ id: x.key, title: x.text }))
    }
    const updatedOptions = [...existingList, { id: value, title: value }]
    const finalUpdatedResult = { items: updatedOptions }
    this.customFieldDef.steps[0].fields.map(x => {
      if (x.key === formField.key) {
        UiHelper.populateOptions(this.customFieldDef, finalUpdatedResult, formField.key)
      }
      return x
    })
    return finalUpdatedResult || {}
  }

  _handelCustomSubmitDeviceAction = async (data) => {
    const { formData, caller } = data
    const payload = { orgId: this.orgId, venueCode: this.state.currentSelectedForAction.deviceCode, action: formData.action }
    // Job API Call
    ApiHelper.call({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'device-actions']),
      jsonBody: payload,
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
      this.setState({ modalOpenDeviceActions: false })
    })
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue: selectedState
    })
  }

  // Search
  _renderSearchBar() {
    return (
      <SearchBar
        onSearch={this.onSearch.bind(this)}
        searchText={this.state.searchText}
        onSinglePickerFilter={this.onStateFilter.bind(this)}
        singleSelectPicker={{
          options: [
            { key: 'LIVE', value: 'LIVE' },
            { key: 'ARCHIVED', value: 'ARCHIVED' },
            { key: '_ALL', value: 'ALL' }
          ],
          defaultValue: this.state.stateFilterValue,
        }}
        resetFilterText={'Reset Filter'}
        // onList={ (this.orgType !== 'PARTNER' || !this.state.tags || !this.state.tags.items || this.state.tags.items.length === 0) ? this.onList.bind(this) : null}
        onList={ (this.orgType !== 'PARTNER') ? this.onList.bind(this) : null}
      />
    );
  }

  onOnlineStatusChange(e) {
    const os = e.target.value
    this.setState({
      onlineStatus: os
    })
  }

  _renderOnlineStatusFilter() {
    return (
      <SingleSelectDropDown
        onSinglePickerFilter={this.onOnlineStatusChange.bind(this)}
        singleSelectPicker={{
          options: [
            { key: 'ONLINE', value: 'ONLINE' },
            { key: 'OFFLINE', value: 'OFFLINE' },
            { key: 'STANDBY', value: 'STANDBY' },
            { key: '_ALL', value: 'ALL' }
          ],
          defaultValue: this.state.onlineStatus,
        }}
      />
    );
  }

  renderAboveTable() {
    if (this.orgType === 'PARTNER') {
      return (
        <Fragment>
          {!AppConfig.FEATURES_OFF.includes('DISPLAY_ADS_PLAYER') && this.state.showAdsPlayer &&
            <VenueAdsPlayer
              isOpen={this.state.showAdsPlayer || false}
              inProcess={this.state.showAdsPlayerLoading || false}
              title={this.state.venueAdsPlayerTitle || Helper.getString('adsPlayButtonTitle')}
              onClosed={() => { this.onCloseAdsPlayer() }}
              ads={this.state.playableAdsList || []}
              orientation={this.state.playerOrientation || ''}
              showError={this.state.adsPlayerError || null}
            ></VenueAdsPlayer>
          }
          <VenueEsperInfo
            isOpen={this.state.esperShowInfo}
            title={(this.state.device && this.state.device.title) ? this.state.device.title : Helper.getString('liveLocation')}
            onClosed={() => this.setState({ esperShowInfo: false })}
            fullWidth={false}
            selectedDevice={this.state.device}
          />
          <DynamicFormDialog
            customSubmit={this._handelCustomSubmitDeviceAction}
            formDefinition={this.fieldDefDeviceActions}
            isOpen={this.state.modalOpenDeviceActions}
            onClosed={() => this.setState({ modalOpenDeviceActions: false })}
          ></DynamicFormDialog>
          <DynamicFormDialog
            onFormFieldOptionAdd={this._handelCustomFieldAddNewOption}
            customSubmit={this._handelCustomFieldSubmit}
            formDefinition={this.customFieldDef}
            isOpen={this.state.showCustomField}
            onClosed={() => this.setState({showCustomField: false})}
          ></DynamicFormDialog>
          <DynamicFormDialog
            customSubmit={this.sendCommandCustomDialogHandle}
            formDefinition={venueCommandsFieldDef.fieldDef}
            isOpen={this.state.showCommandDialog}
            onClosed={() => this.setState({showCommandDialog: false})}
          >
          </DynamicFormDialog>
          <div className={css(Styles.fullWidth)}>
            {/* {!AppConfig.FEATURES_OFF.includes('PARTNER_STATS') && this.state.chartsData && this.state.chartsData.length > 0 && this.state.items && this.state.items.length > 0 &&
              <Grid className={css(Styles.chartsContainer)} container spacing={5}>
                {this.state.chartsData.map((x, index) => {
                  return (
                    <Grid key={'chart_' + index} className={css(Styles.eachChartHolder)} item xs={12} md={3}>
                      <div className={css(Styles.chartBlock)} >
                        {x.chartTitle &&
                          <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                        }
                        <Doughnut data={x.data} options={this.chartOptions} width={200} height={200} />
                      </div>
                    </Grid>
                  )
                })}
              </Grid>
            } */}
            <div className={css(Styles.flexDiv)}>
              <VenueDetails
                isOpen={this.state.showInfo}
                title={ (this.state.device && this.state.device.title) ? this.state.device.title : Helper.getString('venueInfo')}
                onClosed={() => this.setState({ showInfo: false })}
                fullWidth={true}
                selectedDevice={this.state.device}
              />
              {this.orgType === 'PARTNER' &&
                this._renderOnlineStatusFilter()
              }
              {this._renderSearchBar()}
              {/* {this.state.tags && this.state.tags.items && this.state.tags.items.length > 0 && */}
              <MultiselectFilterBar
                value={this.state.selectedTagsId || []}
                onList={this.onList.bind(this)}
                onSearch={this.onTagFilter}
                items={this.state.tags && this.state.tags.items && this.state.tags.items.map(x => {
                  return { key: x.id, title: x.title }
                })}
                placeholder={Helper.getString('selectTags')}
                resetFilterText={'Reset Filter'}
              />
              {/* } */}
            </div>
          </div>
        </Fragment>
      )
    }else if (this.orgType === 'SITE') {
      return (
        <Fragment>
          <VenueDetails
            isOpen={this.state.showInfo}
            title={(this.state.device && this.state.device.title) ? this.state.device.title : Helper.getString('venueInfo')}
            onClosed={() => this.setState({ showInfo: false })}
            fullWidth={true}
            selectedDevice={this.state.device}
          />
          {this._renderSearchBar()}
        </Fragment>
      )
    } else {
      return this._renderSearchBar()
    }
  }

  // onList() {
  //   if (this.searchBarComponent) this.searchBarComponent.setState({ searchText: '' })
  //   this.setState({ selectedFilters: {}, searchText: '', inProcessOnList: true, stateFilterValue: this.defaultState }, () => this.onFacetsFetch())
  // }

  onTagFilter = (selectedTagsId) => {
    this.setState({
      searchText: '',
      selectedTagsId: selectedTagsId
    })
    this.onSearch(null, selectedTagsId)
  }

  onSearch = (searchText, selectedTagsId = []) => {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      searchText: searchText,
      selectedTagsId: searchText ? [] : selectedTagsId,
      chartsData: []
    })
    const params = searchText ? {query: searchText} : {tagsPartner: selectedTagsId.map(x=>x.key).join(',')}
    this.toFetch[0] = { method: 'get', paths: ['miscs', 'venues-of-org'], queryParams: { orgId: this.orgId, pb: 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefDeviceActions', ...params, state:this.state.stateFilterValue, onlinestatus:this.state.onlineStatus }}
    ApiHelper.call(this.toFetch[0], (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false
        })
        return
      }
      this.handleNextpage(result)
      this._changePaginationLimit()
      if(this.displayCheckBoxTable) result.items.map(x => x._selected = false)
      this.sitesById = {
        ...this.sitesById,
        ...(result.sitesById || {})
      }
      for (const item of result.items) {
        if (item.orgId && this.sitesById[item.orgId]) {
          item.siteInfo = { ...this.sitesById[item.orgId] }
        }
      }
      this.setState({
        items: AppHelper.processVenueItems(result.items),
        fetchState: ApiHelper.State.READY
      })
    })
  }

  onList = () => {
    this.toFetch[0] = this.defaultVenueParam
    this.setState({
      searchText: '',
      selectedTagsId: []
    })
    this.fetchItems()
  }

}

const Styles = StyleSheet.create({
  venueColumn:{
    '@media (max-width: 1024px)': {
      minWidth: 250
    }
  },
  customTooltip:{
    fontSize: 12,
  },
  statusHolder:{
    display: 'flex',
    gap: 5,
    flexDirection: 'column',
    minWidth:130
  },
  disableIconStyle:{
    color: '#575757'
  },
  actionIconImage:{
    width: 20,
    height: 20
  },
  indexStyle:{
    fontSize: 16,
    fontWeight: 400
  },
  deviceCodeText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  highlightText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  addressSpan:{
    fontWeight: '600',
    fontSize: '14px',
    color: '#121212'
  },
  sideBySideInfo:{
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0
  },
  sideBySideInfoRows:{
    flex:1
  },
  infoTextHolder:{
    flex: '0 0 48%',
    boxSizing: 'border-box',
    minWidth: 180
  },
  spanValue: {
    // fontSize: 14
  },
  img: {
    height: 30
  },
  line2: {
    fontSize: 12,
    color: '#575757 !important',
    // marginBottom:4
  },
  circleFill:{
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  tagHolder:{
    maxWidth:400,
    marginTop: 4
  },
  tagChip:{
    marginRight:6,
    marginBottom:6,
    maxWidth: 300,
    background:'rgba(87, 87, 87, 0.1)',
    borderRadius:17,
    color: 'rgba(87, 87, 87, 1)',
    fontSize:14,
    padding: '16px 4px'
  },
  fullWidth:{
    width: '100%'
  },
  flexDiv:{
    display: 'flex',
    gap: 10,
    '@media (max-width: 1024px)': {
      flexDirection: 'column'
    }
  },
  chartsContainer:{
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%'
  },
  chartBlock: {
    borderRadius: 16,
    padding: 10,
    background: '#fff',
    marginRight:10,
    overflow: 'hidden',
    maxHeight: 240
  },
  chartTitle:{
    marginBottom: 0
  },
  eachChartHolder:{
    padding:0
  },
  emptyTextHolder:{
    display:'grid'
  },
  emptyImage:{
    maxHeight: 120,
    padding:25
  },
  displayInRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '5px'
  },
  primaryInfo: {
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column'
  },
  infoLinkStyle: {
    color: AppTheme.primaryColor,
    fontWeight: 'bolder'
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/VenuesOrg.js